import React, { Component, CSSProperties } from 'react';

import ProgressBarComponentLayout from './../components/progressBarComponentLayout'

interface IProgressBarComponentProps {
    progress: string
    title?: string
    disableTitle?: boolean
    width?: string
    height?: string
    background?: string
    className?: string
    style?: CSSProperties
    showProgress?: boolean
}

interface IProgressBarComponentState {}

class ProgressBarComponent extends Component<IProgressBarComponentProps, IProgressBarComponentState> {
  render() {
    return (<ProgressBarComponentLayout {...this.props} />)
  }
}

export default ProgressBarComponent;
